import { INavLink } from "interfaces/navLink.interfaces";

export const dietEstablishmentsNavLinks: INavLink[] = [
  {
    id: 1,
    title: "wszystkie założenia",
    path: "/dashboard/diet-establishments",
  },
  {
    id: 2,
    title: "nowe założenia",
    path: "/dashboard/diet-establishments/new",
  },
];
